import Repository from './Repository';

const resource = '/usuarios';

export default {
  getByPerfilId(perfilId) {
    return Repository.get(`${resource}/usuario/perfil/${perfilId}`);
  },
  getDados() {
    return Repository.get(`${resource}/auth`);
  },
  getByUnidade(unidadeId) {
    return Repository.get(`${resource}/unidade/${unidadeId}`);
  },
};
